import { render, staticRenderFns } from "./EbHeading.vue?vue&type=template&id=273af852"
import script from "./EbHeading.vue?vue&type=script&lang=js"
export * from "./EbHeading.vue?vue&type=script&lang=js"
import style0 from "./EbHeading.vue?vue&type=style&index=0&id=273af852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports